/* Non-invasive hydration guardrails for app-injected media */
(function () {
  var AVOID = [
    '.hero-slider',
    '[data-lcp]',
    '.product__media-wrapper',
    '.image-banner',
    '.main-collection-banner'
  ];
  function isInAvoidList(el) {
    try { return AVOID.some(function(sel){ return el.closest(sel); }); } catch (e) { return false; }
  }
  function belowFold(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top > vh * 1.1;
  }
  function tweakImage(img) {
    if (!img || isInAvoidList(img)) return;
    if (!img.loading && belowFold(img)) img.loading = 'lazy';
    if (!img.decoding) img.decoding = 'async';
  }
  function tweakIframe(f) {
    if (!f || isInAvoidList(f)) return;
    if (!f.loading && belowFold(f)) f.loading = 'lazy';
  }
  function scan(root) {
    try {
      root.querySelectorAll('img').forEach(tweakImage);
      root.querySelectorAll('iframe').forEach(tweakIframe);
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ scan(document); });
  } else { scan(document); }
  var mo = new MutationObserver(function(muts){
    muts.forEach(function(m){
      if (!m.addedNodes) return;
      m.addedNodes.forEach(function(n){
        if (n.nodeType !== 1) return;
        if (n.tagName === 'IMG') tweakImage(n);
        else if (n.tagName === 'IFRAME') tweakIframe(n);
        else scan(n);
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Promote first banner/collection banner image to LCP if in viewport
  function promoteLCP() {
    try {
      var candidates = document.querySelectorAll('.image-banner img, .main-collection-banner img, [id^="Banner-"] img');
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i=0; i<candidates.length; i++) {
        var img = candidates[i];
        var r = img.getBoundingClientRect();
        if (r.top < vh * 0.8) { // near top
          try { img.loading = 'eager'; } catch(e){}
          try { img.decoding = 'async'; } catch(e){}
          try { img.fetchPriority = 'high'; } catch(e){}
          break;
        }
      }
    } catch(e){}
  }
  promoteLCP();

})();